// extracted by mini-css-extract-plugin
module.exports = {"place":"TournamentPlace_place__s_0Eh","button":"TournamentPlace_button___21gF"};